import { motion } from "framer-motion";

const container = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,
    transition: { staggerChildren: 0.2 }
  }
};

const itemAnim = {
  hidden: { opacity: 0, scale: 0.9, y: 30 },
  show: { opacity: 1, scale: 1, y: 0, transition: { duration: 0.5 } }
};

function Process() {
  return (
    <section className="process" id="about">
      <motion.div 
        className="section-header"
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        viewport={{ once: true }}
      >
        <span className="section-tag">How It Works</span>
        <h2 className="section-title">Our Development Process</h2>
      </motion.div>

      <motion.div 
        className="steps"
        variants={container}
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, margin: "-50px" }}
      >
        <motion.div className="step" variants={itemAnim}>
          <span className="step-number">01</span>
          <h3>Discovery & Roadmap</h3>
          <p>We baseline your requirements and existing processes to define the optimal Salesforce roadmap.</p>
        </motion.div>

        <motion.div className="step" variants={itemAnim}>
          <span className="step-number">02</span>
          <h3>Solution Design</h3>
          <p>Crafting detailed blueprints for Salesforce architecture, data models, and integrations.</p>
        </motion.div>

        <motion.div className="step" variants={itemAnim}>
          <span className="step-number">03</span>
          <h3>Build & Configure</h3>
          <p>Agile development of declarative features, Apex logic, and Lightning Web Components.</p>
        </motion.div>

        <motion.div className="step" variants={itemAnim}>
          <span className="step-number">04</span>
          <h3>UAT & Go-Live</h3>
          <p>Rigorous User Acceptance Testing followed by managed release to your production org.</p>
        </motion.div>
      </motion.div>
    </section>
  );
}

export default Process;